// Vendors
import React, { useEffect } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'

//Components
import { CardLayout } from 'components/CardLayout'
import { Global300Logo } from 'components/Global300Logo'

// Parts
import { RecoverForm } from './parts/RecoverForm'
import { SuccessRecover } from './parts/SuccessRecover'

// Store
import { RootState } from 'store'

const Recover: React.FC = () => {
  const { success } = useSelector(
    (state: RootState) => state.authReducer.recover
  )
  const { token } = useParams<{ token: string }>()
  const history = useHistory()

  useEffect(() => {
    if (!token) {
      history.push('/')
    }
  }, [token, history])

  return (
    <section
      id="recover-form"
      className="px-4 min-vh-100 d-flex flex-column justify-center"
    >
      <div className="recover_confirm_card container py-3">
        <CardLayout>
          {/* {si success es verdad me retorna el mensaje de exito} */}
          {!success ? <RecoverForm /> : <SuccessRecover />}
        </CardLayout>
      </div>
      <Global300Logo />
    </section>
  )
}

export default Recover
